export default {
    getUsedTrans(trans, state) {
        let usedTrans = {}
        // let langs = _.get(state.curSite, 'langs', ['en_US'])
        let langs = ['en_us', 'zh_hk', 'zh_cn', 'th'];
        // console.log('langs=', langs)
        for (let k of this.used_keys) {
            // console.log('used key=', k)

            for (let lang of langs) {
                let lang_code = lang//.lang_code.toLowerCase()
                // console.log(lang_code, _.get(trans, `${lang_code}.${k}`, _.get(trans, `en_US.${k}`, k)))
                if (!_.has(usedTrans, lang_code)) {
                    usedTrans[lang_code] = {}
                }

                usedTrans[lang_code][k] = _.get(trans, `${lang_code}.${k}`, _.get(trans, `en_US.${k}`, k))
            }

        }

        //console.log('usedTrans=', usedTrans)
        usedTrans['is_filtered2'] = 1;
        return usedTrans
    },
    used_keys: [

    ],


}